import { Flowbite } from 'flowbite-react';
import { ReactNode } from 'react';
import { CUSTOM_FLOWBITE_THEME } from './constants';

export const FlowbiteProvider = ({ children }: { children: ReactNode }) => (
  <Flowbite theme={{ theme: CUSTOM_FLOWBITE_THEME }}>{children}</Flowbite>
);
